<template>
  <div>
    <v-btn v-if="editReference == 0" :disabled="disabled" @click="editReference = 1" color="info">
      <v-icon>folder</v-icon>Change file
    </v-btn>
    <v-card v-if="editReference != 0">
      <v-card-text>
        <div v-if="editReference == 1">
          <h3>Link to autolaw file</h3>
          <v-text-field
            label="Search for file reference"
            v-model="fileidSearchTemp"
            @input="searchFile"
            outline
          />
          <Matter :fileid="fileidSearch" @loaded="updateLoaded(true, $event)">
            <v-btn @click="updateFile()" color="success">
              <v-icon>check_circle</v-icon>Use this
            </v-btn>
          </Matter>
          <v-alert :value="fileidSearch && !fileLoadedSearch" type="warning">No record found</v-alert>
          <v-alert :value="!fileidSearch && !fileLoadedSearch" type="info">No record selected</v-alert>
        </div>
        <div v-if="editReference == 2">
          <h3>Use a free reference</h3>
          <v-form ref="formFreeReference" v-model="valid" lazy-validation>
            <v-text-field
              label="Free reference"
              v-model="freereferenceSearch"
              :rules="valueRules"
              outline
            />
            <v-btn @click="updateFreeReference()" :disabled="!freereferenceSearch" color="success">
              <v-icon>check_circle</v-icon>Use this
            </v-btn>
          </v-form>
        </div>
        <hr />
        <v-btn @click="resetSearch" small>Cancel</v-btn>
        <v-btn @click="editReference = 2" v-if="editReference == 1" small>Not an autolaw file?</v-btn>
        <v-btn @click="editReference = 1" v-if="editReference == 2" small>Autolaw file?</v-btn>
      </v-card-text>
    </v-card>
    <div v-if="fileLoaded">Currently linked to file:</div>
    <Matter :fileid="fileid" @loaded="updateLoaded(false, $event)">
      <v-btn @click="unlink()" color="error" small>Unlink</v-btn>
    </Matter>
    <br v-if="fileLoaded" />
    <p v-if="freereference">
      <span>Currently linked to free reference:</span>
      {{freereference}}
      <a @click="unlink()">Unlink</a>
    </p>
  </div>
</template>

<script>
import Matter from "@/components/file/matter/Matter.vue";
function initialState() {
  return {
    editReference: 0,
    timerId: null,
    fileidSearchTemp: "",
    fileidSearch: null,
    freereferenceSearch: "",
    fileLoadedSearch: false,
    fileLoaded: false,
    valid: false,
    valueRules: [v => !!v || "Value is required"]
  };
}
export default {
  name: "MatterSearch",
  props: ["disabled", "fileid", "freereference"],
  components: { Matter },
  data: function() {
    return initialState();
  },
  methods: {
    updateLoaded(search, value) {
      if (search) {
        this.fileLoadedSearch = value;
      } else {
        this.fileLoaded = value;
      }
    },
    searchFile() {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        this.fileidSearch = this.fileidSearchTemp;
      }, 750);
    },
    updateFile() {
      this.$emit("updateFile", this.fileidSearch);
      this.resetSearch();
    },
    resetSearch() {
      Object.assign(this.$data, initialState());
    },
    updateFreeReference() {
      if (this.$refs.formFreeReference.validate()) {
        this.$emit("updateFreeReference", this.freereferenceSearch);
        this.resetSearch();
      }
    },
    unlink() {
      this.$emit("unlink");
      this.resetSearch();
    }
  }
};
</script>